import {
  getRoiDashboardResponseSchema,
  type GetRoiDashboardResponse,
} from "@mg/schemas/src/christo/catalyst";

import { API_URL } from "../config/env";
import { smartFetch } from "../utils/http";

export interface GetRoiDashboardParams {
  startDate?: string;
  endDate?: string;
}

export async function getRoiDashboard(
  params: GetRoiDashboardParams = {},
): Promise<GetRoiDashboardResponse> {
  const searchParams = new URLSearchParams();

  if (params.startDate) {
    searchParams.set("startDate", params.startDate);
  }
  if (params.endDate) {
    searchParams.set("endDate", params.endDate);
  }

  const queryString = searchParams.toString();
  const url = `${API_URL}/private/catalyst/roi-dashboard${queryString ? `?${queryString}` : ""}`;

  const json = await smartFetch(url, {
    method: "GET",
  });

  try {
    return getRoiDashboardResponseSchema.parse(json);
  } catch (parseError) {
    console.error("Failed to parse ROI dashboard response:", parseError);
    return json as GetRoiDashboardResponse;
  }
}
